var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"allcontain"},[_c('div',{staticClass:"topBar"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/image/logo.jpg"),"alt":""}}),_c('div',{staticClass:"title"},[_vm._v("灵动配音")])])])
}]

export { render, staticRenderFns }